import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";
import { Link } from "react-router";

export default function NotFoundPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="text-center space-y-6 max-w-md">
        <div className="flex justify-center">
          <AlertTriangle className="text-destructive" size={48} />
        </div>
        <h1 className="text-4xl font-bold text-foreground">404 - Page Not Found</h1>
        <p className="text-muted-foreground text-sm">The page you are looking for does not exist or has been moved.</p>
        <Link to="/">
          <Button variant="default" className="mt-4">
            Go back home
          </Button>
        </Link>
      </div>
    </div>
  );
}
